import React, { useState } from "react";
import CtoPopupForm from "./CtoPopupForm";
import "../Style.css";

const CallbackFormTrigger = () => {
  const [showForm, setShowForm] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const openForm = () => {
    setShowForm(true);
    setIsClosing(false);
  };

  const closeForm = () => {
    // Start close animation
    setIsClosing(true);
    // After animation duration (400ms), hide the form
    setTimeout(() => {
      setShowForm(false);
      setIsClosing(false);
    }, 400);
  };

  return (
    <>
      {/* Floating Button */}
      <button onClick={openForm} className="callback-floating-btn">
        <span className="text-sm font-semibold">Get a Call Back</span>
      </button>

      {/* Popup Form with close animation */}
      {showForm && (
        <CtoPopupForm onClose={closeForm} isClosing={isClosing} />
      )}
    </>
  );
};

export default CallbackFormTrigger;
